import styled from "styled-components";

export function Profile(){
    return (
    <>
    <Subheader>The Profile-Page is currently under construction</Subheader>
    <div className="card-container"></div>
    </>)
}

const Subheader = styled.h2`
    text-align: center;
`